<template>
	<div class="share-wrap">
		<a class="item" :href="facebook" @click.prevent="go('facebook')">
			<span class="icon" v-html="icon('facebook')"></span>
			Share
		</a>
		<a class="item" :href="twitter" @click.prevent="go('twitter')">
			<span class="icon" v-html="icon('twitter')"></span>
			Tweet
		</a>
	</div>
</template>

<script>
export default {
	data() {
		return {
			facebook:
				"https://www.facebook.com/sharer/sharer.php?u=https%3A//dimmy.club",
			twitter: "https://twitter.com/home?status=https%3A//dimmy.club"
		};
	},
	methods: {
		go(to) {
			goatevent({
				path: location.host + `-hero-share-${to}`,
				title: `hero share ${to}`,
				event: true
			});
			window.open(this[to], "_blank");
		}
	}
};
</script>

<style lang="scss" scoped>
$color: $grey2;

.share-wrap {
	display: flex;
	flex-direction: row;

	@include mobile {
		display: none;
	}

	.item {
		background-color: $color1-dark;
		margin: 0.5em;
		padding: 0.5em;
		font-size: 0.6em;
		border-radius: 2px;
		text-transform: uppercase;
		font-weight: 600;
		color: $color;
		line-height: 1em;
		display: flex;
		align-items: center;
		transition: background-color $aniTime $aniTiming;

		&:hover {
			background-color: darken($color1-dark, 8%);
		}

		.icon {
			display: inline-flex;
			margin-right: 0.5em;

			::v-deep {
				svg {
					$s: 1.1em;
					width: $s;
					height: $s;

					path {
						fill: $color;
					}
				}
			}
		}
	}
}
</style>
